import { jsonApi } from '@models/jsonApi';

jsonApi.define('integrations/google-big-query/schema-table', {
    label: '',
    id: '',
    mode: '',
    field_type: ''
});
